export const RESET_USER_PASSWORD_URL = '/api/password/reset'
export const UPDATE_USER_PASSWORD_WITH_TOKEN_URL = '/api/password/change'
